export default __webpack_public_path__ + "static/media/eventopsIconLogoWhite.c05950dd.png";